<template>
  <section class="page-user-form">
    <Breadcrumbs :items="breadcrumbs" />

    <div class="content">
      <rp-edit-patient
        @submit="updatePatient"
        :genders="genders"
        :roles="roles"
        :locales="locales"
        :engagementTypes="engagementTypes"
        v-model="form" />

      <terms />
      <rp-overlay :active="active">
        <rp-alert
          icon="done"
          :message="successMessage"
          :onClick="successFunction">
        </rp-alert>
      </rp-overlay>
    </div>
  </section>
</template>

<script>
  import EditPatientForm from 'raypro_ui/src/components/ui/forms/Patient'
  import {updatePatient, getAvailableRoles, getPatient} from 'raypro_ui/src/api/users'
  import {getLocales} from 'raypro_ui/src/api/locales'
  import {getEngagementTypes} from "raypro_ui/src/api/engagement_types";
  import Overlay from 'raypro_ui/src/components/ui/Overlay'
  import Alert from 'raypro_ui/src/components/ui/Alert'
  import page from '@/mixins/page'

  import Terms from '@/components/Terms'
  import Breadcrumbs from '@/components/Breadcrumbs'

  export default {
    data() {
      return {
        errors: {},
        form: {},
        roles: [],
        locales: [],
        engagementTypes: [],
        genders: [
          {'label': 'Male', 'value': 'M'},
          {'label': 'Female', 'value': 'F'},
          {'label': 'Prefer not to say', 'value': 'O'}
        ],
        active: false,
        successMessage: 'Patient updated successfully!',
        breadcrumbs: [
          {
            label: 'My Patients',
            link: 'all-patients'
          },
          {label: 'Edit Patient'}
        ],
        title: 'Edit Patient'
      }
    },

    mixins: [page],

    mounted() {
      this.getRoles()
      this.getPatient()
      this.getLocales()
      this.getEngagementTypes()
    },

    computed: {
      userPayload() {
        const form = this.form

        return {
          patient: {
            'email': form.email,
            'user_roles': [{'role_id': form.role}],
            'locale_id': form.locale,
            'patient_id': form.patient_id,
            'profile': {
              'first_name': form.first_name,
              'last_name': form.last_name,
              'gender': form.gender,
              'yob': form.yob,
              'phone': form.phone,
              'engagement_type_id': form.engagement_type_id
            }
          }
        }
      }
    },

    props: {id: String},

    components: {
      'rp-edit-patient': EditPatientForm,
      'rp-overlay': Overlay,
      'rp-alert': Alert,
      Terms,
      Breadcrumbs
    },

    methods: {
      getLocales() {
        getLocales()
          .then(({data}) => {
            this.locales = data
          })
          .catch(() => {
            alert('Cannot get locales')
          })
      },

      getEngagementTypes() {
        getEngagementTypes()
          .then(({ data }) => {
            this.engagementTypes = data;
          })
          .catch(() => {
            alert("Cannot get engagement types");
          });
      },

      successFunction() {
        this.$router.push({name: 'all-patients'})
      },

      getRoles() {
        getAvailableRoles().then(({data}) => {
          this.roles = data.available_roles.map((role) => {
            return {key: role.name, value: role.id}
          })
        })
      },

      getPatient() {
        getPatient(this.id).then(({data}) => {
          this.form = {
            'patient_id': data.patient_id,
            'email': data.email,
            'role': data.roles[0].id,
            'first_name': data.profile.first_name,
            'last_name': data.profile.last_name,
            'gender': data.profile.gender,
            'locale': data.locale.id,
            'yob': data.profile.yob,
            'phone': data.profile.phone,
            'engagement_type_id': data.profile.engagement_type_id
          }
        })
      },

      updatePatient() {
        updatePatient(this.id, this.userPayload)
          .then(() => {
            this.active = true
          })
          .catch(({response}) => {
            // TODO: map errors to flat structure for form
            this.errors = response.errors
          })
      }
    }
  }
</script>

<style lang="sass">
</style>



// WEBPACK FOOTER //
// src/components/pages/Patients/EditPatient.vue